module.exports = __webpack_public_path__ + "img/a2-s27.d7c26e31.jpg";